import { createEntityAdapter, createSlice, EntityState, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { EmailType } from '../../models/EmailType'

interface EmailTypesState {
  isLoading: boolean
  emailTypes: EntityState<EmailType, string>
}

const emailTypesAdapter = createEntityAdapter<EmailType>()

const initialState: EmailTypesState = {
  isLoading: true,
  emailTypes: emailTypesAdapter.getInitialState(),
}

export const emailTypeSlice = createSlice({
  name: 'emailTypes',
  initialState,
  reducers: {
    setEmailTypesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setEmailTypes: (state, action: PayloadAction<EmailType[]>) => {
      emailTypesAdapter.setAll(state.emailTypes, action.payload)
    },
    resetEmailTypes: () => initialState,
  },
})

export const { setEmailTypesLoading, setEmailTypes, resetEmailTypes } = emailTypeSlice.actions

const emailTypeSelectors = emailTypesAdapter.getSelectors((state: RootState) => state.emailHub.emailTypes.emailTypes)

export const selectEmailTypes = (state: RootState) => emailTypeSelectors.selectAll(state)

export const selectEmailTypesLoading = (state: RootState) => state.emailHub.emailTypes.isLoading
